document.addEventListener('click', function(e) {
  const el = e.target;
  // global select div icon - Yudi
  if(el.classList.contains('global-select-div-icon') || el.closest('.global-select-div-icon')) {
    const selectDivEl = el.classList.contains('global-select-div-icon') ? el : el.closest('.global-select-div-icon');

    document.querySelectorAll('.global-select-div-icon.active').forEach(function(gsd) {
        if(gsd != selectDivEl) {
            gsd.classList.remove('active');
        }
    });

    if(selectDivEl.classList.contains('active')) {
        selectDivEl.classList.remove('active');
    } else {
        selectDivEl.classList.add('active');
    }
  } else {
    document.querySelectorAll('.global-select-div-icon.active').forEach(function(gsd) {
        gsd.classList.remove('active');
    });
  }
  if(el.classList.contains('option') && el.closest('.global-select-div-icon')) {
    const optionEl = el;
    const select = optionEl.closest('.options').nextElementSibling;
    select.value = optionEl.getAttribute('data-value');
    select.dispatchEvent(new Event('change'));
    select.closest('.global-select-div-icon').querySelector('.inner .text').innerHTML = optionEl.innerHTML;
  }
})


// cust

function addStarProduct(elem, type, callback){
  document.querySelectorAll(elem).forEach(function(elem){
    elem.onclick = function(e){
      e.preventDefault();
      var quantity = 1;
      let formData = {
        'items': [{
         'id': elem.getAttribute('data-variant-id'),
         'quantity': quantity
         }]
       };
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if(window.enablePromotionsUsingCode || window.autoPromotionsEnable) {
          window.cart_clear = false;
          window.promotionValidate();
        }
        setTimeout(function(){
          if(type == 'checkout'){
            window.location.href = '/checkout';
          }
          else{
            if (callback) callback();
            theme.Cart.prototype._onProductAdded();
          }
        }, 1000);
      });
    };
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    addStarProduct('.checkoutButton', 'checkout');
  });
} else {
  addStarProduct('.checkoutButton', 'checkout');
}
